const demo_app = {
    landing_title: 'Ứng dụng nghiệp vụ (Demo)',
    landing_subtitle: 'Trang này đóng vai một ứng dụng nghiệp vụ (Sat Alert / eLogbook / IUU). Đăng nhập bằng tài khoản Sat-Alert IAM để tiếp tục.',
    login_button: 'Đăng nhập bằng Sat-Alert IAM',
    title: 'Đăng nhập thành công',
    subtitle: 'Bạn đã đăng nhập với tài khoản:',
    username: 'Tên đăng nhập: ',
    user_id: 'ID người dùng: ',
    sign_out: 'Đăng xuất',
    continue_explore: 'Hoặc tiếp tục khám phá',
    customize_sign_in_experience: 'Tùy chỉnh trải nghiệm đăng nhập',
    enable_passwordless: 'Bật đăng nhập không cần mật khẩu',
    add_social_connector: 'Thêm connector mạng xã hội',
};
export default Object.freeze(demo_app);
